import { useCallback } from 'react';
import { generatePath, PathParam } from 'react-router';

import { useSelectedClientId } from '../useSelectedClientId';

export function useGeneratePathWithCurrentClient() {
  const clientId = useSelectedClientId();

  const generatePathEnhanced = useCallback(
    <Path extends `/:clientId/${string}`>(
      path: Path,
      params?: {
        [key in Exclude<PathParam<Path>, 'clientId'>]: string | null;
      },
    ) => {
      return generatePath(path as `/:clientId/${string}`, { ...params, clientId });
    },
    [clientId],
  );

  return generatePathEnhanced;
}
